import React from 'react'
import { Link } from 'react-router-dom'
import StoreDetailsAdd from './StoreDetailsAdd'

class StoreDetailsAddTab extends React.Component {
  state = {}
  componentDidMount() {
    if (
      this.props.match.params.storeDetail_id !== undefined &&
      this.props.match.params.storeDetail_id !== null &&
      this.props.match.params.storeDetail_id !== 0 &&
      this.props.match.params.storeDetail_id !== ''
    ) {
      this.setState({ storeDetail_id: this.props.match.params.storeDetail_id })
    }
  }
  handleLanguage = (language_id) => {
    this.setState({ language_id: language_id })
  }
  render() {
    return (
      <div className="main-body">
        <div className="page-wrapper">
          <div className="page-header">
            <div className="row align-items-end">
              <div className="col-lg-8">
                <div className="page-header-title">
                  <div className="d-inline">
                    <h4>{this.props.match.params.storeDetail_id ? 'Edit' : 'Add'} Store Details</h4>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="page-header-breadcrumb">
                  <ul className="breadcrumb-title">
                    <li className="breadcrumb-item">
                      <Link to="/">
                        <i className="feather icon-home"></i>{' '}
                      </Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/store-details">Store Details</Link>
                    </li>
                    <li className="breadcrumb-item active">
                      {this.props.match.params.storeDetail_id ? 'Edit' : 'Add'} Store Details
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="page-body">
            <div className="row">
              <div className="col-sm-12">
                <div className="card card-border-default">
                  <div className="card-block">
                    <div className="tab-content tabs">
                      <div
                        className="tab-pane  active"
                        id={'add_Store_' + this.state.language_id}
                        role="tabpanel"
                        aria-labelledby=""
                      >
                        {this.state.storeDetail_id !== undefined &&
                        this.state.storeDetail_id !== null &&
                        this.state.storeDetail_id !== 0 &&
                        this.state.storeDetail_id !== '' ? (
                          <StoreDetailsAdd
                            language_id={this.state.language_id}
                            goBack={this.props.history.goBack}
                            storeDetail_id={this.state.storeDetail_id}
                          />
                        ) : (
                          <StoreDetailsAdd
                            language_id={this.state.language_id}
                            goBack={this.props.history.goBack}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default StoreDetailsAddTab
